import { render, staticRenderFns } from "./EditFolderModal.vue?vue&type=template&id=69dc205e&scoped=true&"
import script from "./EditFolderModal.vue?vue&type=script&lang=js&"
export * from "./EditFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc205e",
  null
  
)

export default component.exports